import * as React from "react";
import { useTranslation } from "react-i18next";
import { Search } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Kbd } from "./kbd";
import { cn } from "@/lib/utils";

export interface SearchBarProps extends React.ComponentProps<typeof Input> {
  shortcutHint?: string;
}

export function SearchBar({
  shortcutHint = "⌘ K",
  className,
  placeholder,
  ...props
}: SearchBarProps) {
  const { t } = useTranslation();
  const resolvedPlaceholder = placeholder ?? t("common.search.placeholder");
  return (
    <div className={cn("relative", className)}>
      <Search
        size={14}
        className="pointer-events-none absolute left-2.5 top-1/2 -translate-y-1/2 text-ink-400"
      />
      <Input placeholder={resolvedPlaceholder} className="pl-8 pr-12" {...props} />
      <span className="pointer-events-none absolute right-2 top-1/2 -translate-y-1/2">
        <Kbd>{shortcutHint}</Kbd>
      </span>
    </div>
  );
}
